import axios from "axios";
import store from "@/store";
const homepageURL = process.env.VUE_APP_BASE_URL;

export const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
   headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    // Get the authorization token from store
    const tokenDataBase64Encoded = store.getters.token;
    if (tokenDataBase64Encoded) {
      try {
        // Decode the base64 string
        const decodedtokenData = atob(tokenDataBase64Encoded);

        // Parse the JSON string
        const jsonObject = JSON.parse(decodedtokenData);
        //console.log("token decoded: ", jsonObject);

        // Access the token property
        const token = jsonObject.access_token;

        if (token) {
          //console.log(`Access token: ${token}`);
          config.headers.Authorization = `Bearer ${token}`;
        }
        // config.headers["Access-Control-Allow-Origin"] = "*";
        return config;
      } catch (error) {
        // Handle any errors that occur during parsing or modification
        //console.error("Error in apiInterceptor:", error);

        this.$store.commit("setLogout");
        window.location.href = homepageURL;
      }
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
instance.interceptors.response.use(
  (response) => {
    //console.log("interceptor response:", response);
    // If the response is successful, return it as is
    return response;
  },
  (error) => {
    //console.log("interceptor error:", error);

    if (error.response && error.response.status === 401) {
      // If the response has a 401 status code (Unauthorized)

      // Log the user out by calling a Vuex mutation
      store.commit("setLogout");
      //console.log("after setLogout");

      // Redirect to home page
      window.location.href = homepageURL;

      // Return a rejected promise with the original error
      return Promise.reject(error);
    }

    // For other errors, just reject the promise with the original error
    return Promise.reject(error);
  }
);
